<template>
    <div class="contenedor_contenido">
        <b-container fluid="">
            <b-row>
                <div class="col-sm-12 mt-1">
                    <b-tabs content-class="mt-1" fill>
                        <b-tab v-if="permisos['inventarios.movimientos.entradas']?.ver || ES_ROOT" title="Entradas"
                            active @click="set_modulo('entradas')"></b-tab>
                        <b-tab v-if="permisos['inventarios.movimientos.salidas']?.ver || ES_ROOT" title="Salidas"
                            @click="set_modulo('salidas')"></b-tab>
                    </b-tabs>
                </div>
            </b-row>
        </b-container>

        <Entradas v-if="modulo == 'entradas'" />
        <Salidas v-if="modulo == 'salidas'" />
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import Entradas from './Entradas/Entrada.vue'
    import Salidas from './Salidas/Salida.vue'

    export default {
        name: 'Movimiento',
        components: {
            Entradas,
            Salidas
        },
        computed: {
            ...mapState(['permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT'])
        },
        data() {
            return {
                modulo: 'entradas'
            }
        },
        methods: {
            set_modulo(modulo) {
                this.modulo = modulo
            }
        },
        mounted() {
            if (this.permisos['inventarios.movimientos.entradas']?.ver) {
                this.modulo == 'entradas'
            } else if (this.ES_ROOT) {
                this.modulo = 'entradas'
            } else {
                this.modulo = ''
            }
        },
    }
</script>

<style></style>